import * as React from 'react';
import * as styles from './styles.css';

export interface IFiltersProps {
  regionFilter: React.ReactNode;
  dealTypeFilter: React.ReactNode;
  offerTypeFilter: React.ReactNode;
  searchTextFilter: React.ReactNode;
}

export function Filters({ dealTypeFilter, offerTypeFilter, searchTextFilter, regionFilter }: IFiltersProps) {
  return (
    <div className={styles['container']}>
      <div className={styles['inner-container']}>
        <div className={styles['main']}>
          <div className={styles['filter-item']}>{regionFilter}</div>
          <div className={styles['filter-item']}>{dealTypeFilter}</div>
          <div className={styles['filter-item']}>{offerTypeFilter}</div>
        </div>
        <div className={styles['second']}>{searchTextFilter}</div>
      </div>
    </div>
  );
}
